/**
 * 功能未开放占位页面
 *
 * 当功能开关关闭时，替代实际页面内容展示给用户。
 */

import { Lock } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

interface FeatureDisabledPageProps {
  /** 功能名称（如"导演模式"） */
  featureName: string;
  /** 可选的描述文字 */
  description?: string;
}

export function FeatureDisabledPage({ featureName, description }: FeatureDisabledPageProps) {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-slate-50 to-slate-100 p-4">
      <div className="text-center max-w-md">
        <div className="w-16 h-16 bg-slate-100 rounded-2xl flex items-center justify-center mx-auto mb-6 border border-slate-200">
          <Lock className="w-8 h-8 text-slate-400" />
        </div>
        <h1 className="text-xl font-semibold text-slate-800 mb-2">
          {featureName}暂未开放
        </h1>
        <p className="text-sm text-slate-500 mb-6">
          {description || '该功能当前未开放，请稍后再试或联系管理员。'}
        </p>
        <button
          onClick={() => navigate('/')}
          className="px-5 py-2.5 bg-accent-blue text-white rounded-xl text-sm font-medium hover:shadow-lg active:scale-[0.98] transition-all"
        >
          返回首页
        </button>
      </div>
    </div>
  );
}
